import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import { devConfig, profile } from 'config/config'; // Importing devConfig and profile from configuration
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { countries } from 'config/config'; // Importing countries data from configuration

export default class FilterBonusReportView extends JetView {
    // Defining FilterBonusReportView class extending JetView
    config() {
        // Method to define the configuration of the view
        const _ = this.app.getService('locale')._; // Getting localization service
        const left = {
            // Defining the left section of the layout
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    cols: [
                        // Columns in the left section
                        {
                            view: 'text', // Text input for date range
                            name: 'Datepicker', // Name of the input
                            id: 'Datepicker', // ID of the input
                            css: 'reportrange', // CSS class for styling
                            readonly: true, // Making the input read-only
                            // Label for the input with icon
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker input
                            name: 'Date', // Name of the input
                            id: 'Date', // ID of the input
                            stringResult: true, // Return date as string
                            minWidth: 200, // Minimum width of the input
                            // Label for the input with icon
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to current date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                // Suggest options for the datepicker
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date selectable is today
                                },
                            },
                        },
                        {
                            view: 'richselect', // Rich select input for country selection
                            name: 'CountrySelect', // Name of the input
                            id: 'CountrySelect', // ID of the input
                            minWidth: 200, // Minimum width of the input
                            localId: 'regions:combo', // Local ID for referencing
                            // Label for the input with icon
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                // Options for the rich select
                                body: {
                                    template: function (obj) {
                                        // Template for displaying options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            // Conditional visibility based on configuration
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Another rich select for country selection
                            name: 'CountrySelect2', // Name of the input
                            minWidth: 200, // Minimum width of the input
                            localId: 'regions:combo', // Local ID for referencing
                            // Label for the input with icon
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Making the input read-only
                            options: {
                                // Options for the rich select
                                body: {
                                    template: function (obj) {
                                        // Template for displaying options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            // Conditional visibility based on configuration
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                            css: 'country-hide', // Additional CSS class for hiding
                        },
                        {
                            view: 'richselect', // Rich select input for bonus type selection
                            name: 'BonusType', // Name of the input
                            localId: 'bonusTypes:combo', // Local ID for referencing
                            label: _('Tipo'), // Label for the input
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the bonus type
                                { id: '', value: _('Todos') },
                                { id: '2', value: _('Deposito') },
                                { id: '3', value: _('No Deposito') },
                                { id: '6', value: _('FreeBet') },
                            ],
                        },
                        {
                            view: 'text', // Text input for Partner Bonus ID
                            name: 'PartnerBonusId', // Name of the input
                            type: 'number', // Input type
                            // Label for the input with icon
                            label: "<span class='icon-id'></span>" + _('Partner Bono Id'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Bono ID'), // Placeholder text
                            invalidMessage: _('Partner Bonus Id is required'), // Error message for validation
                        },
                        {
                            view: 'text', // Text input for Player ID
                            name: 'PlayerId', // Name of the input
                            type: 'number', // Input type
                            minWidth: 200, // Minimum width of the input
                            // Label for the input with icon
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Cliente'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('ID Cliente'), // Placeholder text
                            invalidMessage: _('Client ID is required'), // Error message for validation
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            // Upper section of the layout
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section
                },
            ],
        };
        const buttons = {
            // Button section for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    width: 90, // Button width
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Button type
                    width: 100, // Button width
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            // Check if country report is enabled
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            // Conditional logic based on date type
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if needed
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            // Second button section for actions
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'), // Button label
                    click: () => {
                        $$('myForm2').clear(); // Clear the second form
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Button type
                    click: () => {
                        // Click event handler
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            // Conditional logic based on date type
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if needed
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            // Accordion section for filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Initial state of the accordion
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5', // ID for the accordion section
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            // Another accordion section for scrolling
            view: 'scrollview', // Scrollable view
            scroll: 'xy', // Scroll in both directions
            body: {
                padding: 10,
                rows: [upper_section], // Including upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window', // Window view
            move: true, // Allow moving the window
            id: 'filterPopup', // ID for the popup
            fullscreen: true, // Fullscreen mode
            head: {
                // Header of the popup
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the header
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2', // ID for the form
                type: 'clean', // Clean type for styling
                rows: [accordion_section3, buttons2], // Including accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            // Returning the main configuration object
            view: 'form', // Main form view
            type: 'clean', // Clean type for styling
            rows: [
                screen.width > 500 && screen.height > 500 // Conditional rendering based on screen size
                    ? accordion_section // Show accordion section if conditions are met
                    : { height: 1, width: 0 }, // Otherwise, render an empty object
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }
    init(grid) {
        // Initialization method
        webix.ready(function () {
            // Webix ready function
            if (profile.typeDate !== 2) {
                // Conditional logic based on date type
                $$('Date').hide(); // Hide date input
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Attach event after rendering datepicker
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
